import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast, ToastContainer } from "react-toastify";
import { axiosInstance } from "../services/apiServices";
import axios from "axios";
import CryptoJS from "crypto-js";

function DeleteUser() {
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("user"));

  const history = useHistory();

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleButtonClick = () => {
    if (inputValue === userInfo?.primaryEmail) {
      setIsLoading(true);
      // Define your API URL and headers
      const apiUrl = "/signup_svc/pv/users/deleteUserAccounVerfication";
      const headers = {
        "Content-Type": "application/json",
        // Authorization: "Bearer YOUR_ACCESS_TOKEN", // Add your authentication token if needed
      };

      // Create the data you want to send to the API
      const data = {
        primaryEmail: inputValue,
        modifiedBy: userInfo?.id,
      };

      const encryptUserId = () => {
        const base64Key = process.env.REACT_APP_BASE64_KEY;
        const base64Iv = process.env.REACT_APP_BASE64_KEY_IV;
        const key = CryptoJS.enc.Base64.parse(base64Key);
        const iv = CryptoJS.enc.Base64.parse(base64Iv);
        const encrypted = CryptoJS.AES.encrypt(userInfo?.id + "", key, {
          iv: iv,
        });
        return encrypted.toString();
      };

      // Make the POST request
      axios
        .post(`${process.env.REACT_APP_PLEXAAR_URL}${apiUrl}`, data, {
          headers: {
            "Content-Type": "application/json",
            userId: encryptUserId(),
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })

        .then((response) => {
          if (response.data.code === 0) {
            setIsLoading(false);
            history.push(`/deleteaccountotp/${inputValue}`);
          } else {
            setIsLoading(false);
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          toast.error(error);
          console.error("Error:", error);
        });
    } else {
      setIsLoading(false);
      alert("Enter primary email of your account");
    }
  };

  return (
    <div className="row">
      <div className="col-5 mx-auto vh-100 d-flex flex-column align-items-center justify-content-center">
        <h6 className="mb-3">Enter Email to delete account</h6>
        <input
          className="form-control del-account-input"
          type="mail"
          placeholder="Enter email"
          value={inputValue}
          onChange={handleInputChange}
        />
        <button className="btn mt-3 del-account" onClick={handleButtonClick}>
          {isLoading ? (
            <div className="spinner-border text-light" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            "Delete"
          )}
        </button>
      </div>
      <ToastContainer />
    </div>
  );
}

export default DeleteUser;
